<template>

</template>

<script>
export default {
  name: 'default-loading'
}
</script>

<style scoped lang="scss">

</style>
